import config from '@/fixtures/config';
import * as Sentry from '@sentry/react';

Sentry.init({
  enabled: config.isProduction,
  dsn: 'https://0ee7b1140c374dc1fddcca7004b2dc44@o939871.ingest.us.sentry.io/5889735',
  integrations: [],
});
